
export const serverAppConfig = {
  "storeId": "67d3fd8c7603516611665578",
  "categories": [
    {
      "id": "67ed329ca77b29394356d989",
      "name": "Sortiment",
      "slug": "sortiment",
      "description": "Upptäck vårt omfattande sortiment av hälsoprodukter, inklusive vitaminer, kosttillskott och naturliga skönhetsprodukter för ditt välbefinnande.",
      "thumbnailDescription": "Brett sortiment av vitaminer, kosttillskott och naturliga skönhetsprodukter.",
      "additionalText": "<p>Vårt sortiment av hälsoprodukter är noggrant utvalt för att stödja din hälsa och skönhet. Oavsett om du letar efter dagliga vitaminer, specifika kosttillskott eller naturliga skönhetsprodukter, har vi något för alla. Utforska våra produkter och hitta det som passar dina behov bäst.</p>",
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_sortiment.png",
      "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_sortiment.png",
      "order": 1,
      "metaTitle": "Utforska Vårt Omfattande Sortiment av Hälsoprodukter",
      "metaDescription": "Upptäck ett brett utbud av hälsoprodukter som vitaminer, kosttillskott och naturliga skönhetsprodukter för att främja ditt välbefinnande.",
      "metaHeader": "Hälsoprodukter för Ditt Välbefinnande",
      "subCategories": [
        {
          "id": "67ed329ca77b29394356d98a",
          "name": "Vitaminer",
          "slug": "sortiment-vitaminer",
          "description": "Stärk din hälsa med vårt utbud av vitamintillskott, från A-vitamin till K-vitamin, för att stödja kroppens funktioner och immunförsvar.",
          "thumbnailDescription": "Utforska vårt breda utbud av vitaminer för optimal hälsa.",
          "additionalText": "<p>Vitaminer är avgörande för att upprätthålla en hälsosam kropp och ett starkt immunförsvar. Vårt sortiment erbjuder en mängd olika vitaminer som är utformade för att stödja dina specifika hälsobehov. Oavsett om du behöver A-vitamin för synen, D-vitamin för benhälsan eller K-vitamin för blodkoagulering, har vi något för dig. Investera i din hälsa idag med våra högkvalitativa vitamintillskott.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_vitaminer.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_vitaminer.png",
          "order": 2,
          "metaTitle": "Förbättra Din Hälsa med Våra Vitamintillskott",
          "metaDescription": "Upptäck vårt omfattande sortiment av vitamintillskott, från A-vitamin till K-vitamin, för att stärka kroppens funktioner och immunförsvar.",
          "metaHeader": "Stärk Din Hälsa med Vitamintillskott",
          "subCategories": [
            {
              "id": "67ed329ca77b29394356d98b",
              "name": "Vitamin B",
              "slug": "sortiment-vitaminer-vitamin-b",
              "description": "B-vitaminer för energi, nervsystem och mentalt fokus – från B1 till B12 i rena former.",
              "thumbnailDescription": "Utforska rena B-vitaminer för energi och fokus.",
              "additionalText": "<p>Våra B-vitaminer är noggrant utvalda för att ge dig den bästa möjliga stödet för din hälsa. Oavsett om du behöver mer energi, vill stärka ditt nervsystem eller förbättra ditt mentala fokus, har vi rätt vitamin för dig. Från B1 till B12, våra produkter är formulerade för att möta dina specifika behov.</p>",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_vitaminer.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_vitaminer.png",
              "order": 3,
              "metaTitle": "B-vitaminer: Energi, Nervsystem och Mentalt Fokus",
              "metaDescription": "Upptäck vårt sortiment av B-vitaminer, från B1 till B12, i sina renaste former. Perfekt för att stödja energi, nervsystem och mentalt fokus.",
              "metaHeader": "B-vitaminer för Optimal Hälsa",
              "subCategories": null
            },
            {
              "id": "67ed329ca77b29394356d992",
              "name": "Vitamin K",
              "slug": "sortiment-vitaminer-vitamin-k",
              "description": "Vitamin K för normal blodkoagulering och benhälsa – ofta i kombination med D-vitamin.",
              "thumbnailDescription": "Utforska Vitamin K:s roll i blodkoagulering och benhälsa.",
              "additionalText": "<p>Vitamin K är avgörande för att säkerställa att blodet koagulerar normalt, vilket minskar risken för blödningar. Dessutom spelar det en viktig roll i att stärka skelettet genom att förbättra benhälsan. När det kombineras med D-vitamin, kan dessa vitaminer arbeta synergistiskt för att ytterligare stödja kroppens hälsa. Genom att inkludera Vitamin K i din dagliga kost kan du främja både blodets och benens välbefinnande.</p>",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_vitaminer.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_vitaminer.png",
              "order": 7,
              "metaTitle": "Vitamin K: Nyckeln till Blodkoagulering och Benhälsa",
              "metaDescription": "Upptäck hur Vitamin K bidrar till normal blodkoagulering och stärker benhälsan. Lär dig mer om fördelarna med att kombinera Vitamin K med D-vitamin för optimal hälsa.",
              "metaHeader": "Fördelarna med Vitamin K för Blod och Ben",
              "subCategories": null
            },
            {
              "id": "67ed329ca77b29394356d998",
              "name": "Multi Vitaminer",
              "slug": "sortiment-vitaminer-multi-vitaminer",
              "description": "Högkvalitativa multivitaminer med balanserade näringsämnen för dagligt stöd till hela kroppen.\n",
              "thumbnailDescription": "Utforska våra multivitaminer för dagligt stöd och välbefinnande.",
              "additionalText": "<p>Våra multivitaminer är formulerade för att ge ett omfattande näringsstöd som hjälper till att upprätthålla din hälsa och vitalitet. Med en noggrant balanserad blandning av vitaminer och mineraler, är de perfekta för att komplettera din dagliga kost och säkerställa att du får de näringsämnen du behöver.</p>",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_vitaminer.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_vitaminer.png",
              "order": 1,
              "metaTitle": "Bästa Multivitaminer för Dagligt Kroppsstöd",
              "metaDescription": "Upptäck vårt sortiment av högkvalitativa multivitaminer med noggrant balanserade näringsämnen. Perfekt för dagligt stöd och optimal hälsa.",
              "metaHeader": "Högkvalitativa Multivitaminer för Optimal Hälsa",
              "subCategories": null
            },
            {
              "id": "67ed329ca77b29394356d9a8",
              "name": "Vitamin A",
              "slug": "sortiment-vitaminer-vitamin-a",
              "description": "Vitamin A-tillskott för syn, hud och immunförsvar – viktigt för kroppens förnyelseprocesser.",
              "thumbnailDescription": "Stärk din kropp med Vitamin A-tillskott för bättre syn, hud och immunförsvar.",
              "additionalText": "<p>Vitamin A är en essentiell näringsämne som spelar en avgörande roll i kroppens förnyelseprocesser. Det bidrar till att bibehålla en god syn, främjar hudens hälsa och stärker immunförsvaret. Genom att inkludera Vitamin A-tillskott i din dagliga rutin kan du säkerställa att din kropp får det stöd den behöver för att fungera optimalt. Utforska vårt sortiment av Vitamin A-produkter och hitta det perfekta tillskottet för dina behov.</p>",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_vitaminer.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_vitaminer.png",
              "order": 2,
              "metaTitle": "Vitamin A-tillskott: Förbättra Syn, Hud och Immunförsvar",
              "metaDescription": "Upptäck fördelarna med Vitamin A-tillskott för att stödja syn, hudhälsa och ett starkt immunförsvar. Viktigt för kroppens förnyelseprocesser.",
              "metaHeader": "Vitamin A: Nyckeln till Hälsa och Förnyelse",
              "subCategories": null
            },
            {
              "id": "67ed329ca77b29394356d9aa",
              "name": "Vitamin E",
              "slug": "sortiment-vitaminer-vitamin-e",
              "description": "Antioxidanten vitamin E skyddar cellerna mot oxidativ stress och bidrar till frisk hud och vävnad.",
              "thumbnailDescription": "Skydda dina celler och främja frisk hud med vitamin E.",
              "additionalText": "<p>Vitamin E är en kraftfull antioxidant som spelar en avgörande roll i att skydda kroppens celler från skadliga fria radikaler. Genom att inkludera vitamin E i din dagliga rutin kan du inte bara stärka ditt immunförsvar utan också förbättra hudens elasticitet och utseende. Utforska vårt breda sortiment av vitamin E-produkter och hitta den perfekta lösningen för dina behov.</p>",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_vitaminer.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_vitaminer.png",
              "order": 6,
              "metaTitle": "Upptäck Fördelarna med Vitamin E: Skydd och Frisk Hud",
              "metaDescription": "Lär dig hur antioxidanten vitamin E skyddar dina celler mot oxidativ stress och bidrar till en frisk hud och vävnad. Utforska vårt sortiment av vitamin E-produkter.",
              "metaHeader": "Vitamin E: Din Sköld mot Oxidativ Stress",
              "subCategories": null
            },
            {
              "id": "67ed329ca77b29394356d9ab",
              "name": "Vitamin D",
              "slug": "sortiment-vitaminer-vitamin-d",
              "description": "D-vitamintillskott för starkt immunförsvar, skelett och humör – särskilt viktigt under vinterhalvåret.",
              "thumbnailDescription": "Stärk ditt immunförsvar och skelett med D-vitamin.",
              "additionalText": "<p>D-vitamin är avgörande för att upprätthålla ett starkt immunförsvar och ett friskt skelett. Under vinterhalvåret, när solen är en sällsynt syn, kan D-vitamintillskott vara en viktig del av din dagliga rutin för att säkerställa att du får tillräckligt med detta viktiga näringsämne. Förutom att stödja immunförsvaret och skelettet, kan D-vitamin också bidra till att förbättra ditt humör och allmänna välbefinnande. Utforska vårt sortiment av D-vitamintillskott och hitta det som passar dina behov bäst.</p>",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_vitaminer.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_vitaminer.png",
              "order": 5,
              "metaTitle": "D-vitamintillskott för Optimalt Immunförsvar och Skelettstyrka",
              "metaDescription": "Upptäck fördelarna med D-vitamintillskott för att stärka ditt immunförsvar, förbättra skelettets hälsa och lyfta ditt humör, särskilt under de mörka vintermånaderna.",
              "metaHeader": "Förbättra Din Hälsa med D-vitamintillskott",
              "subCategories": null
            },
            {
              "id": "67ed329da77b29394356d9b6",
              "name": "Vitamin C",
              "slug": "sortiment-vitaminer-vitamin-c",
              "description": "Naturligt C-vitamin för immunförsvar, cellskydd och upptag av järn – från acerola, camu camu och mer.",
              "thumbnailDescription": "Stärk ditt immunförsvar med naturligt C-vitamin från acerola och camu camu.",
              "additionalText": "<p>Vårt sortiment av naturligt C-vitamin erbjuder en kraftfull kombination av acerola och camu camu, kända för sina höga halter av C-vitamin. Dessa naturliga källor hjälper inte bara till att stärka immunförsvaret utan bidrar också till cellskydd och förbättrat järnupptag. Utforska våra produkter och upplev de hälsofrämjande fördelarna med naturligt C-vitamin.</p>",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_vitaminer.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_vitaminer.png",
              "order": 4,
              "metaTitle": "Naturligt C-vitamin: Stärk ditt immunförsvar och cellskydd",
              "metaDescription": "Upptäck fördelarna med naturligt C-vitamin från acerola och camu camu. Förbättra ditt immunförsvar, skydda dina celler och öka järnupptaget med vårt sortiment av vitamin C-produkter.",
              "metaHeader": "Naturligt C-vitamin för Optimalt Hälsa",
              "subCategories": null
            }
          ]
        },
        {
          "id": "67ed329ca77b29394356d98c",
          "name": "Kosttillskott",
          "slug": "sortiment-kosttillskott",
          "description": "Optimera din näring med våra högkvalitativa kosttillskott, inklusive omega-3, probiotika och multivitaminer, för en balanserad livsstil.",
          "thumbnailDescription": "Utforska våra premium kosttillskott för en balanserad livsstil.",
          "additionalText": "<p>Våra kosttillskott är noggrant utvalda för att ge dig de näringsämnen du behöver för att må bra varje dag. Oavsett om du letar efter omega-3 för hjärthälsa, probiotika för en bättre matsmältning, eller multivitaminer för allmän hälsa, har vi något för dig. Investera i din hälsa med våra pålitliga produkter.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_kosttillskott.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_kosttillskott.png",
          "order": 5,
          "metaTitle": "Optimera Din Hälsa med Våra Premium Kosttillskott",
          "metaDescription": "Upptäck vårt sortiment av högkvalitativa kosttillskott, inklusive omega-3, probiotika och multivitaminer, för att stödja en balanserad och hälsosam livsstil.",
          "metaHeader": "Förbättra Din Näring med Våra Kosttillskott",
          "subCategories": null
        },
        {
          "id": "67ed329ca77b29394356d98d",
          "name": "Allergi",
          "slug": "sortiment-allergi",
          "description": "Lindra dina allergisymptom med våra naturliga allergiprodukter, såsom antihistaminer och nässprayer, för en bekvämare vardag.",
          "thumbnailDescription": "Lindra allergisymptom med våra naturliga produkter för en bekvämare vardag.",
          "additionalText": "<p>Våra naturliga allergiprodukter är utformade för att ge dig den lindring du behöver utan onödiga kemikalier. Oavsett om du lider av säsongsallergier eller året runt, erbjuder vi ett brett utbud av lösningar som kan hjälpa dig att hantera dina symptom effektivt. Utforska våra antihistaminer och nässprayer för att hitta den perfekta produkten för dina behov.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_allergi.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_allergi.png",
          "order": 16,
          "metaTitle": "Naturliga Allergiprodukter för Lindring av Allergisymptom",
          "metaDescription": "Upptäck vårt sortiment av naturliga allergiprodukter, inklusive antihistaminer och nässprayer, för att lindra dina allergisymptom och förbättra din vardag.",
          "metaHeader": "Effektiv Lindring av Allergisymptom med Naturliga Produkter",
          "subCategories": null
        },
        {
          "id": "67ed329ca77b29394356d98e",
          "name": "Aminosyror & protein",
          "slug": "sortiment-aminosyror-protein",
          "description": "Främja muskeluppbyggnad och återhämtning med våra aminosyratillskott, inklusive BCAA och L-glutamin, för optimal träningseffekt.",
          "thumbnailDescription": "Förbättra din träning med våra BCAA och L-glutamin tillskott.",
          "additionalText": "<p>Våra aminosyratillskott är speciellt utformade för att stödja muskeluppbyggnad och påskynda återhämtningen efter intensiva träningspass. Med en kombination av BCAA och L-glutamin kan du säkerställa att din kropp får de näringsämnen den behöver för att prestera på topp. Oavsett om du är en erfaren atlet eller nybörjare, kan våra produkter hjälpa dig att nå dina träningsmål snabbare och mer effektivt.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_aminosyror.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_aminosyror.png",
          "order": 12,
          "metaTitle": "Maximera Muskeluppbyggnad med Våra Aminosyratillskott",
          "metaDescription": "Upptäck hur våra aminosyratillskott, inklusive BCAA och L-glutamin, kan främja muskeluppbyggnad och återhämtning för optimal träningseffekt.",
          "metaHeader": "Främja Din Träning med Aminosyror",
          "subCategories": null
        },
        {
          "id": "67ed329ca77b29394356d98f",
          "name": "Hudvård",
          "slug": "sortiment-hudvard",
          "description": "Ge din hud näring med vår naturliga hudvård, inklusive ekologiska krämer och serum, för en strålande och hälsosam hy.",
          "thumbnailDescription": "Ge din hud näring med vår naturliga hudvård för en strålande och hälsosam hy.",
          "additionalText": "<p>Vår hudvårdsserie är noggrant utvald för att erbjuda de bästa naturliga och ekologiska produkterna. Våra krämer och serum är framtagna för att ge din hud den näring och vård den förtjänar, utan skadliga kemikalier. Oavsett om du har torr, fet eller känslig hy, har vi något som passar just dig. Utforska vårt sortiment och upplev skillnaden med naturlig hudvård.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_hudvård.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_hudvård.png",
          "order": 14,
          "metaTitle": "Naturlig Hudvård för Strålande Hy - Ekologiska Krämer & Serum",
          "metaDescription": "Upptäck vårt sortiment av naturlig hudvård med ekologiska krämer och serum. Ge din hud den näring den behöver för att stråla av hälsa och skönhet.",
          "metaHeader": "Naturlig Hudvård: Ekologiska Krämer & Serum",
          "subCategories": null
        },
        {
          "id": "67ed329ca77b29394356d990",
          "name": "Hjärna & Ögon",
          "slug": "sortiment-hjarna-ogon",
          "description": "Stöd din kognitiva funktion och syn med våra specialiserade tillskott, inklusive omega-3 och lutein, för mental skärpa och ögonhälsa.\n",
          "thumbnailDescription": "Specialiserade tillskott för kognitiv funktion och synhälsa.",
          "additionalText": "<p>Våra tillskott är noggrant utvalda för att ge dig den bästa möjliga stödet för både hjärna och ögon. Omega-3 är känt för sina fördelar för hjärnans funktion, medan lutein är viktigt för att bibehålla en god ögonhälsa. Utforska vårt sortiment och hitta de rätta produkterna för dina behov.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_hjärna-ögon.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_hjärna-ögon.png",
          "order": 18,
          "metaTitle": "Förbättra Din Kognitiva Funktion och Syn med Våra Tillskott",
          "metaDescription": "Upptäck våra specialiserade tillskott som omega-3 och lutein för att stödja mental skärpa och ögonhälsa. Optimera din hjärna och syn med vårt sortiment.",
          "metaHeader": "Stöd Din Hjärna och Ögon med Våra Tillskott",
          "subCategories": null
        },
        {
          "id": "67ed329ca77b29394356d991",
          "name": "Rogivande",
          "slug": "sortiment-rogivande",
          "description": "Främja avslappning och god sömn med våra rogivande produkter, såsom valeriana och melatonin, för ökat välbefinnande.\n",
          "thumbnailDescription": "Utforska våra produkter för avslappning och god sömn, inklusive valeriana och melatonin.",
          "additionalText": "<p>Vårt sortiment av rogivande produkter är noggrant utvalt för att hjälpa dig att uppnå en djupare och mer vilsam sömn. Valeriana och melatonin är kända för sina lugnande egenskaper och kan bidra till att minska stress och förbättra sömnkvaliteten. Oavsett om du har svårt att somna eller bara vill förbättra din sömnrutin, har vi produkterna för dig. Utforska vårt utbud och hitta den perfekta lösningen för dina behov.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_rogivande.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_rogivande.png",
          "order": 19,
          "metaTitle": "Främja Avslappning och Sömn med Våra Rogivande Produkter",
          "metaDescription": "Upptäck vårt sortiment av rogivande produkter som valeriana och melatonin för att förbättra ditt välbefinnande och främja god sömn.",
          "metaHeader": "Rogivande Produkter för Bättre Sömn och Välbefinnande",
          "subCategories": null
        },
        {
          "id": "67ed329ca77b29394356d993",
          "name": "Eteriska Oljor",
          "slug": "sortiment-eteriska-oljor",
          "description": "Utforska vårt utbud av eteriska oljor för aromaterapi, inklusive lavendel och pepparmynta, för naturlig avslappning och energi.",
          "thumbnailDescription": "Hitta din balans med våra eteriska oljor för naturlig avslappning och energi.",
          "additionalText": "<p>Våra eteriska oljor är noggrant utvalda för att ge dig den bästa upplevelsen av aromaterapi. Lavendelolja är känd för sina lugnande egenskaper, medan pepparmyntsolja kan ge en uppfriskande energikick. Oavsett om du vill koppla av efter en lång dag eller få en energiboost på morgonen, har vi något för dig. Utforska vårt sortiment och hitta den perfekta oljan för dina behov.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_eteriska-oljor.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_eteriska-oljor.png",
          "order": 23,
          "metaTitle": "Upptäck Eteriska Oljor för Aromaterapi: Naturlig Avslappning & Energi",
          "metaDescription": "Utforska vårt breda sortiment av eteriska oljor, inklusive lavendel och pepparmynta, för att främja naturlig avslappning och öka energinivåerna.",
          "metaHeader": "Eteriska Oljor för Aromaterapi",
          "subCategories": null
        },
        {
          "id": "67ed329ca77b29394356d994",
          "name": "Djur",
          "slug": "sortiment-djur",
          "description": "Ge dina husdjur det bästa med våra naturliga djurprodukter, inklusive kosttillskott och ekologisk djurvård, för deras hälsa och vitalitet.\n",
          "thumbnailDescription": "Naturliga produkter för husdjurens hälsa och välmående.",
          "additionalText": "<p>Våra naturliga djurprodukter är noggrant utvalda för att säkerställa att dina husdjur får den bästa vården. Från kosttillskott som stödjer deras immunförsvar till ekologiska vårdprodukter som skyddar deras hud och päls, erbjuder vi allt du behöver för att hålla dina husdjur friska och glada. Utforska vårt sortiment idag och upptäck skillnaden naturliga produkter kan göra.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_djur-crop.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_djur.png",
          "order": 22,
          "metaTitle": "Naturliga Djurprodukter för Optimal Hälsa och Vitalitet",
          "metaDescription": "Upptäck vårt sortiment av naturliga djurprodukter, inklusive kosttillskott och ekologisk djurvård, för att ge dina husdjur det bästa för deras hälsa och vitalitet.",
          "metaHeader": "Ge Ditt Husdjur Det Bästa med Naturliga Produkter",
          "subCategories": null
        },
        {
          "id": "67ed329ca77b29394356d995",
          "name": "Livsmedel",
          "slug": "sortiment-livsmedel",
          "description": "Njut av hälsosamma och ekologiska livsmedel, inklusive superfoods och glutenfria alternativ, för en näringsrik kost.\n",
          "thumbnailDescription": "Hälsosamma och ekologiska alternativ för en balanserad kost.",
          "additionalText": "<p>Vårt sortiment av livsmedel är noggrant utvalt för att erbjuda dig de bästa ekologiska och näringsrika alternativen. Oavsett om du letar efter superfoods för att boosta din energi eller glutenfria produkter för att passa din diet, har vi något för alla. Utforska våra produkter och ta ett steg mot en hälsosammare livsstil idag.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_livsmedel.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_livsmedel.png",
          "order": 24,
          "metaTitle": "Upptäck Ekologiska och Hälsosamma Livsmedel för en Näringsrik Kost",
          "metaDescription": "Utforska vårt sortiment av ekologiska livsmedel, superfoods och glutenfria alternativ för att främja en hälsosam livsstil.",
          "metaHeader": "Ekologiska och Hälsosamma Livsmedel",
          "subCategories": null
        },
        {
          "id": "67ed329ca77b29394356d996",
          "name": "Vattenrening",
          "slug": "sortiment-vattenrening",
          "description": "Förbättra ditt dricksvatten med våra vattenreningsprodukter, inklusive filter och destillatorer, för rent och hälsosamt vatten varje dag.\n",
          "thumbnailDescription": "Utforska våra effektiva vattenreningslösningar för ett friskare liv.",
          "additionalText": "<p>Vatten är en grundläggande del av vår hälsa och välbefinnande. Med våra högkvalitativa vattenreningsprodukter kan du enkelt förbättra kvaliteten på ditt dricksvatten. Våra filter och destillatorer är designade för att avlägsna föroreningar och ge dig det renaste vattnet möjligt. Oavsett om du vill förbättra smaken, lukten eller säkerheten i ditt vatten, har vi lösningen för dig. Investera i din hälsa idag med våra pålitliga och effektiva vattenreningsprodukter.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_vattenrening.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_vattenrening.png",
          "order": 9,
          "metaTitle": "Förbättra Ditt Dricksvatten med Våra Vattenreningsprodukter",
          "metaDescription": "Upptäck vårt sortiment av vattenreningsprodukter, inklusive filter och destillatorer, för att säkerställa rent och hälsosamt vatten varje dag.",
          "metaHeader": "Rent och Hälsosamt Vatten Varje Dag",
          "subCategories": null
        },
        {
          "id": "67ed329ca77b29394356d997",
          "name": "Alger",
          "slug": "sortiment-alger",
          "description": "Upptäck näringsrika alger som spirulina och chlorella i vårt sortiment, perfekta för detox och energiboost.\n",
          "thumbnailDescription": "Spirulina och chlorella: Superfoods för din hälsa.",
          "additionalText": "<p>Våra alger, spirulina och chlorella, är kända för sina hälsofördelar. De är rika på vitaminer, mineraler och antioxidanter, vilket gör dem till ett utmärkt val för att stödja kroppens naturliga detoxprocesser och ge en energiboost. Oavsett om du är nybörjare eller en erfaren användare av superfoods, kommer vårt sortiment att hjälpa dig att uppnå dina hälsomål.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_alger.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_alger.png",
          "order": 25,
          "metaTitle": "Upptäck Kraften i Näringsrika Alger: Spirulina & Chlorella",
          "metaDescription": "Utforska vårt sortiment av näringsrika alger som spirulina och chlorella. Perfekta för detox och energiboost, dessa superfoods är ett måste för en hälsosam livsstil.",
          "metaHeader": "Näringsrika Alger för Detox och Energi",
          "subCategories": null
        },
        {
          "id": "67ed329ca77b29394356d999",
          "name": "Mineraler",
          "slug": "sortiment-mineraler",
          "description": "Säkerställ ditt dagliga intag av viktiga mineraler som järn, kalcium och magnesium med våra mineraltillskott för stark kropp och sinne.",
          "thumbnailDescription": "Stärk kropp och sinne med våra mineraltillskott.",
          "additionalText": "<p>Våra mineraltillskott är noggrant utvalda för att ge dig de nödvändiga näringsämnena som stödjer en aktiv och hälsosam livsstil. Oavsett om du behöver extra järn för energi, kalcium för starka ben eller magnesium för muskelavslappning, har vi produkterna för dig. Utforska vårt sortiment och hitta det perfekta tillskottet för dina behov.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_mineraler.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_mineraler.png",
          "order": 3,
          "metaTitle": "Optimera Din Hälsa med Våra Mineraltillskott",
          "metaDescription": "Upptäck vårt sortiment av mineraltillskott som säkerställer ditt dagliga intag av viktiga mineraler som järn, kalcium och magnesium. Stärk din kropp och ditt sinne med våra högkvalitativa produkter.",
          "metaHeader": "Säkerställ Ditt Dagliga Mineralintag",
          "subCategories": [
            {
              "id": "67ed329ca77b29394356d99a",
              "name": "Järn",
              "slug": "sortiment-mineraler-jarn",
              "description": "Järntillskott som stödjer blodbildning och energinivåer – skonsamma alternativ för känsliga magar.",
              "thumbnailDescription": "Effektiva och skonsamma järntillskott för bättre blodbildning och energi.",
              "additionalText": "<p>Våra järntillskott är noggrant utformade för att ge stöd åt din kropp utan att irritera magen. Perfekt för dig som söker ett milt men effektivt alternativ för att förbättra blodbildning och energinivåer. Utforska vårt sortiment av mineraler och hitta det järntillskott som passar dina behov bäst.</p>",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_mineraler.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_mineraler.png",
              "order": 1,
              "metaTitle": "Järntillskott för Optimal Blodbildning och Energi",
              "metaDescription": "Upptäck våra skonsamma järntillskott som stödjer blodbildning och energinivåer, speciellt framtagna för känsliga magar.",
              "metaHeader": "Skonsamma Järntillskott för Känsliga Magar",
              "subCategories": null
            },
            {
              "id": "67ed329ca77b29394356d99b",
              "name": "Kalcium",
              "slug": "sortiment-mineraler-kalcium",
              "description": "Kalcium för starka ben och tänder – viktiga tillskott för både barn, vuxna och äldre.",
              "thumbnailDescription": "Utforska våra kalciumprodukter för starka ben och tänder.",
              "additionalText": "<p>Kalcium är ett essentiellt mineral som spelar en avgörande roll i att bygga och underhålla starka ben och tänder. Oavsett om du är ett växande barn, en aktiv vuxen eller en äldre person, är det viktigt att få i sig tillräckligt med kalcium för att stödja kroppens behov. Vårt sortiment av kalciumtillskott är noggrant utvalt för att passa alla åldersgrupper och livsstilar. Investera i din hälsa idag och upptäck fördelarna med kalcium för ett starkare och friskare liv.</p>",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_mineraler.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_mineraler.png",
              "order": 2,
              "metaTitle": "Kalcium: Nyckeln till Starka Ben och Tänder för Alla Åldrar",
              "metaDescription": "Upptäck vårt sortiment av kalciumtillskott som stödjer starka ben och tänder. Perfekt för barn, vuxna och äldre som vill säkerställa ett optimalt intag av detta viktiga mineral.",
              "metaHeader": "Kalciumtillskott för Hela Familjen",
              "subCategories": null
            },
            {
              "id": "67ed329ca77b29394356d99c",
              "name": "Krom",
              "slug": "sortiment-mineraler-krom",
              "description": "Krom bidrar till stabilt blodsocker och normal ämnesomsättning – särskilt vid sockerbalans.",
              "thumbnailDescription": "Lär dig hur krom kan hjälpa till att balansera blodsockret och stödja ämnesomsättningen.",
              "additionalText": "<p>Krom är ett viktigt mineral som spelar en avgörande roll i kroppens förmåga att hantera blodsockernivåer. Genom att inkludera krom i din kost kan du främja en mer stabil blodsockernivå och en effektiv ämnesomsättning. Detta är särskilt viktigt för personer som strävar efter att balansera sitt sockerintag och förbättra sin allmänna hälsa. Utforska vårt sortiment av kromtillskott för att hitta det som passar dina behov bäst.</p>",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_mineraler.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_mineraler.png",
              "order": 3,
              "metaTitle": "Krom: Nyckeln till Stabilt Blodsocker och Normal Ämnesomsättning",
              "metaDescription": "Upptäck hur krom kan bidra till att upprätthålla stabilt blodsocker och stödja en normal ämnesomsättning. Perfekt för dem som vill balansera sitt sockerintag.",
              "metaHeader": "Fördelarna med Krom för Blodsocker och Ämnesomsättning",
              "subCategories": null
            },
            {
              "id": "67ed329ca77b29394356d99d",
              "name": "Magnesium",
              "slug": "sortiment-mineraler-magnesium",
              "description": "Magnesium för muskler, nerver och återhämtning – i lättupptagliga, bioaktiva former.",
              "thumbnailDescription": "Utforska magnesium i lättupptagliga former för bättre hälsa.",
              "additionalText": "<p>Magnesium är ett viktigt mineral för kroppens funktioner, särskilt för muskler och nerver. Våra produkter erbjuder magnesium i former som kroppen lätt kan absorbera, vilket stödjer både fysisk prestation och återhämtning. Perfekt för dig som vill optimera din hälsa och välmående.</p>",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_mineraler.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_mineraler.png",
              "order": 4,
              "metaTitle": "Magnesium: Nyckeln till Muskelhälsa och Återhämtning",
              "metaDescription": "Upptäck vårt sortiment av magnesium i bioaktiva former för optimal muskel- och nervfunktion samt snabbare återhämtning.",
              "metaHeader": "Magnesium för Muskler, Nerver och Återhämtning",
              "subCategories": null
            },
            {
              "id": "67ed329ca77b29394356d99e",
              "name": "Multi Mineraler",
              "slug": "sortiment-mineraler-multi-mineraler",
              "description": "Ett komplett tillskott med kroppens viktigaste mineraler – för balans och helhet.",
              "thumbnailDescription": "Håll din kropp i balans med våra essentiella multimineraler.",
              "additionalText": "<p>Våra multimineraler är noggrant utformade för att ge dig en balanserad blandning av de viktigaste mineralerna som din kropp behöver. Oavsett om du vill förbättra din allmänna hälsa eller stödja specifika kroppsfunktioner, är våra produkter det perfekta valet för dig. Utforska vårt sortiment idag och upplev skillnaden.</p>",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_mineraler.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_mineraler.png",
              "order": 5,
              "metaTitle": "Upptäck Kompletta Multimineraler för Kroppens Balans",
              "metaDescription": "Utforska vårt sortiment av multimineraler som erbjuder ett komplett tillskott av kroppens viktigaste mineraler. Perfekt för att stödja din hälsa och välbefinnande.",
              "metaHeader": "Kompletta Multimineraler för Optimal Hälsa",
              "subCategories": null
            },
            {
              "id": "67ed329ca77b29394356d99f",
              "name": "Selen",
              "slug": "sortiment-mineraler-selen",
              "description": "Selen är en kraftfull antioxidant som skyddar cellerna och stärker immunförsvaret.",
              "thumbnailDescription": "Selen är en viktig antioxidant som skyddar cellerna och stärker immunförsvaret. Utforska vårt sortiment av selenprodukter.",
              "additionalText": "<p>Selen är ett essentiellt mineral som spelar en avgörande roll i att skydda kroppen mot oxidativ stress och stärka immunförsvaret. Genom att inkludera selen i din dagliga kost kan du förbättra din hälsa och välbefinnande. Vårt sortiment av selenprodukter erbjuder högkvalitativa alternativ för att säkerställa att du får tillräckligt med detta viktiga näringsämne.</p>",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_mineraler.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_mineraler.png",
              "order": 6,
              "metaTitle": "Upptäck Fördelarna med Selen: En Kraftfull Antioxidant",
              "metaDescription": "Lär dig hur selen, en viktig antioxidant, skyddar dina celler och stärker ditt immunförsvar. Utforska vårt sortiment av mineraler och upptäck hur selen kan förbättra din hälsa.",
              "metaHeader": "Selen: Din Kropps Skyddande Antioxidant",
              "subCategories": null
            },
            {
              "id": "67ed329ca77b29394356d9a0",
              "name": "Zink",
              "slug": "sortiment-mineraler-zink",
              "description": "Zink för hud, hår, immunförsvar och hormonbalans – viktigt för kroppens funktioner.",
              "thumbnailDescription": "Zink: Viktigt för hud, hår och immunförsvar.",
              "additionalText": "<p>Zink är ett essentiellt mineral som spelar en avgörande roll i många av kroppens processer. Det bidrar till att bibehålla en frisk hud och starkt hår, samtidigt som det stödjer immunförsvaret och hjälper till att balansera hormoner. Vårt sortiment av zinktillskott är noggrant utvalt för att ge dig de bästa fördelarna. Oavsett om du vill förbättra din hudhälsa, stärka ditt hår eller stödja ditt immunförsvar, kan zink vara en viktig del av din dagliga hälsorutin.</p>",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_mineraler.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_mineraler.png",
              "order": 7,
              "metaTitle": "Zink: Nyckeln till Hälsa för Hud, Hår och Immunförsvar",
              "metaDescription": "Upptäck hur zink kan förbättra din hud, stärka ditt hår och stödja ditt immunförsvar. Utforska vårt sortiment av zinktillskott för optimal hormonbalans och kroppsfunktion.",
              "metaHeader": "Fördelarna med Zink för Kroppens Funktioner",
              "subCategories": null
            },
            {
              "id": "67ed329ca77b29394356d9b2",
              "name": "Bor",
              "slug": "sortiment-mineraler-bor",
              "description": "Bor är ett spårämne som stödjer benhälsa och hormonell balans – ofta i kombination med magnesium.",
              "thumbnailDescription": "Utforska bor och dess roll i att stödja benhälsa och hormonell balans.",
              "additionalText": "<p>Bor är ett essentiellt spårämne som ofta förbises men spelar en avgörande roll i att upprätthålla starka ben och en balanserad hormonell funktion. När det kombineras med magnesium, kan bor bidra till att förbättra kroppens förmåga att absorbera och använda kalcium, vilket är avgörande för benhälsan. Dessutom kan bor hjälpa till att reglera hormoner, vilket kan vara särskilt fördelaktigt för kvinnor under klimakteriet. Genom att inkludera bor i din dagliga kost kan du stödja din övergripande hälsa och välbefinnande.</p>",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_mineraler.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_mineraler.png",
              "order": 8,
              "metaTitle": "Fördelarna med Bor: Stöd för Benhälsa och Hormonell Balans",
              "metaDescription": "Upptäck hur bor, i kombination med magnesium, kan främja starka ben och hormonell balans. Lär dig mer om detta viktiga spårämne och dess hälsofördelar.",
              "metaHeader": "Bor: Ett Viktigt Spårämne för Din Hälsa",
              "subCategories": null
            },
            {
              "id": "67ed329ca77b29394356d9b3",
              "name": "Jod",
              "slug": "sortiment-mineraler-jod",
              "description": "Jod bidrar till normal sköldkörtelfunktion och ämnesomsättning – särskilt viktigt vid låg jodintag.",
              "thumbnailDescription": "Lär dig om jodens roll i sköldkörtelfunktion och ämnesomsättning.",
              "additionalText": "<p>Jod är ett essentiellt mineral som spelar en avgörande roll i att stödja sköldkörtelns funktion och kroppens ämnesomsättning. Vid lågt jodintag kan det vara särskilt viktigt att säkerställa tillräckligt intag för att undvika hälsoproblem. Vårt sortiment av mineraler erbjuder högkvalitativa jodtillskott för att hjälpa dig att upprätthålla en balanserad och hälsosam livsstil.</p>",
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_mineraler.png",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_mineraler.png",
              "order": 9,
              "metaTitle": "Jod: Viktigt för Sköldkörtelfunktion och Ämnesomsättning",
              "metaDescription": "Upptäck hur jod bidrar till normal sköldkörtelfunktion och ämnesomsättning, särskilt vid lågt jodintag. Utforska vårt sortiment av mineraler med fokus på jod.",
              "metaHeader": "Jod och Dess Betydelse för Kroppens Funktioner",
              "subCategories": null
            }
          ]
        },
        {
          "id": "67ed329ca77b29394356d9a1",
          "name": "Sport & Träning",
          "slug": "sortiment-sport-traning",
          "description": "Maximera din prestation med våra sport- och träningsprodukter, inklusive proteinpulver och energitillskott, för effektiv träning.",
          "thumbnailDescription": "Utforska våra produkter för att förbättra din träning och prestation.",
          "additionalText": "<p>Våra sport- och träningsprodukter är noggrant utvalda för att ge dig den bästa möjliga upplevelsen. Oavsett om du är en nybörjare eller en erfaren atlet, har vi något för dig. Våra proteinpulver och energitillskott är designade för att stödja din kropp under träning och hjälpa dig att återhämta dig snabbare. Besök vår webbplats för att se hela vårt sortiment och hitta de produkter som passar dina behov bäst.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_sport-träning.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_sport-träning.png",
          "order": 13,
          "metaTitle": "Maximera Din Prestation med Våra Sport- och Träningsprodukter",
          "metaDescription": "Upptäck vårt breda sortiment av sport- och träningsprodukter, inklusive högkvalitativt proteinpulver och energitillskott, för att optimera din träning och nå dina mål.",
          "metaHeader": "Effektiv Träning med Våra Produkter",
          "subCategories": null
        },
        {
          "id": "67ed329ca77b29394356d9a2",
          "name": "Led & Muskel",
          "slug": "sortiment-led-muskel",
          "description": "Stöd dina leder och muskler med våra specialtillskott, såsom glukosamin och MSM, för ökad rörlighet och komfort.",
          "thumbnailDescription": "Förbättra rörlighet och komfort med glukosamin och MSM.",
          "additionalText": "<p>Våra specialtillskott är utformade för att ge optimal näring till dina leder och muskler. Genom att inkludera glukosamin och MSM i din dagliga rutin kan du uppleva förbättrad rörlighet och minskad obehag. Utforska vårt sortiment och hitta det perfekta tillskottet för dina behov.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_led-muskel.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_led-muskel.png",
          "order": 11,
          "metaTitle": "Optimera Led- och Muskelhälsa med Våra Specialtillskott",
          "metaDescription": "Upptäck våra högkvalitativa tillskott som glukosamin och MSM för att stödja dina leder och muskler. Förbättra din rörlighet och komfort med vårt noggrant utvalda sortiment.",
          "metaHeader": "Stöd Dina Leder och Muskler med Våra Specialtillskott",
          "subCategories": null
        },
        {
          "id": "67ed329ca77b29394356d9a3",
          "name": "ÖrtExtrakt",
          "slug": "sortiment-ortextrakt",
          "description": "Utforska kraften i naturen med våra örtextrakt, inklusive ginseng och echinacea, för naturligt välbefinnande.\n",
          "thumbnailDescription": "Förbättra ditt välbefinnande med kraften i ginseng och echinacea.",
          "additionalText": "<p>Våra örtextrakt är noggrant utvalda för att ge dig de bästa fördelarna från naturen. Ginseng är känt för att öka energi och förbättra mental klarhet, medan echinacea kan stärka ditt immunförsvar. Utforska vårt sortiment och hitta den perfekta kombinationen för dina behov.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_örtextrakt.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_örtextrakt.png",
          "order": 4,
          "metaTitle": "Upptäck Naturligt Välbefinnande med Våra Örtextrakt",
          "metaDescription": "Utforska de hälsofrämjande egenskaperna hos våra örtextrakt, inklusive ginseng och echinacea, för att främja ditt naturliga välbefinnande.",
          "metaHeader": "Naturligt Välbefinnande med Örtextrakt",
          "subCategories": null
        },
        {
          "id": "67ed329ca77b29394356d9a4",
          "name": "Mage & Tarm",
          "slug": "sortiment-mage-tarm",
          "description": "Främja en hälsosam matsmältning med våra produkter för mage och tarm, inklusive probiotika och fibrer, för inre balans.",
          "thumbnailDescription": "Stöd din matsmältning med våra noggrant utvalda produkter för mage och tarm.",
          "additionalText": "<p>Våra produkter är utformade för att främja en hälsosam matsmältning och inre balans. Genom att inkludera probiotika och fibrer i din dagliga rutin kan du förbättra din tarmhälsa och uppnå en bättre livskvalitet. Utforska vårt sortiment och hitta de rätta produkterna för dina behov.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_mage-tarm.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_mage-tarm.png",
          "order": 26,
          "metaTitle": "Främja Hälsosam Matsmältning med Våra Mage- och Tarmprodukter",
          "metaDescription": "Upptäck vårt sortiment av produkter för mage och tarm, inklusive probiotika och fibrer, för att stödja en balanserad och hälsosam matsmältning.",
          "metaHeader": "Mage- och Tarmhälsa: Probiotika och Fibrer för Inre Balans",
          "subCategories": null
        },
        {
          "id": "67ed329ca77b29394356d9a5",
          "name": "Superfoods",
          "slug": "sortiment-superfoods",
          "description": "Boost din hälsa med våra superfoods, såsom gojibär och chiafrön, rika på antioxidanter och näringsämnen.",
          "thumbnailDescription": "Utforska våra antioxidantrika superfoods som gojibär och chiafrön.",
          "additionalText": "<p>Våra superfoods är noggrant utvalda för att ge dig de bästa näringsämnena och antioxidanterna. Gojibär är kända för sina hälsofördelar, inklusive förbättrad immunfunktion och ökad energi. Chiafrön är en utmärkt källa till omega-3, fiber och protein. Genom att inkludera dessa superfoods i din kost kan du enkelt förbättra din hälsa och välbefinnande. Besök vår butik för att utforska hela vårt sortiment och hitta de perfekta superfoods för dina behov.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_superfoods.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_superfoods.png",
          "order": 6,
          "metaTitle": "Förbättra Din Hälsa med Våra Näringsrika Superfoods",
          "metaDescription": "Upptäck vårt sortiment av superfoods, inklusive gojibär och chiafrön, som är fulla av antioxidanter och viktiga näringsämnen för en hälsosammare livsstil.",
          "metaHeader": "Superfoods för Optimal Hälsa",
          "subCategories": null
        },
        {
          "id": "67ed329ca77b29394356d9a6",
          "name": "Homeopati",
          "slug": "sortiment-homeopati",
          "description": "Utforska vårt utbud av homeopatiska medel för naturlig hälsa och balans, anpassade efter dina individuella behov.",
          "thumbnailDescription": "Naturliga lösningar för hälsa och balans med vårt homeopatiska sortiment.",
          "additionalText": "<p>Vårt sortiment av homeopatiska medel erbjuder en holistisk approach till hälsa, med produkter som är utformade för att stödja kroppens naturliga läkningsprocesser. Oavsett om du söker lindring för specifika besvär eller vill främja allmän välbefinnande, har vi något för dig. Våra produkter är noggrant utvalda för att säkerställa högsta kvalitet och effektivitet. Utforska våra alternativ och hitta den perfekta lösningen för dina individuella behov.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_homeopati.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_homeopati.png",
          "order": 27,
          "metaTitle": "Upptäck Homeopatiska Medel för Naturlig Hälsa och Balans",
          "metaDescription": "Utforska vårt omfattande sortiment av homeopatiska medel, noggrant utvalda för att främja naturlig hälsa och balans. Anpassade lösningar för dina unika behov.",
          "metaHeader": "Homeopatiska Medel för Din Hälsa",
          "subCategories": null
        },
        {
          "id": "67ed329ca77b29394356d9a7",
          "name": "Detox",
          "slug": "sortiment-detox",
          "description": "Rena din kropp med våra detoxprodukter, inklusive avgiftande teer och tillskott, för en fräsch start.\n",
          "thumbnailDescription": "Utforska våra detoxprodukter för en renare och friskare kropp.",
          "additionalText": "<p>Våra detoxprodukter är noggrant utvalda för att stödja din kropps naturliga reningsprocesser. Med en kombination av avgiftande teer och tillskott kan du enkelt integrera dessa produkter i din dagliga rutin. Oavsett om du vill starta en ny hälsosam livsstil eller bara ge din kropp en välbehövlig paus, erbjuder vårt sortiment något för alla. Låt oss hjälpa dig att uppnå en balanserad och vitaliserad kropp.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_detox.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_detox.png",
          "order": 15,
          "metaTitle": "Rena Din Kropp med Våra Effektiva Detoxprodukter",
          "metaDescription": "Upptäck vårt sortiment av detoxprodukter, inklusive avgiftande teer och tillskott, för en fräsch och hälsosam start. Förbättra ditt välbefinnande med naturliga ingredienser.",
          "metaHeader": "Effektiv Detox för En Fräsch Start",
          "subCategories": null
        },
        {
          "id": "67ed329ca77b29394356d9a9",
          "name": "Antioxidanter",
          "slug": "sortiment-antioxidanter",
          "description": "Skydda dina celler med våra antioxidanttillskott, såsom vitamin C och E, för att motverka fria radikaler.\n",
          "thumbnailDescription": "Stärk ditt immunförsvar med våra vitamin C och E tillskott.",
          "additionalText": "<p>Fria radikaler kan orsaka skador på dina celler, men med våra antioxidanttillskott kan du stärka ditt försvar. Våra produkter är noggrant utvalda för att ge dig det bästa skyddet mot oxidativ stress. Utforska vårt sortiment och hitta det perfekta tillskottet för dina behov.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_anitoxidanter.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_anitoxidanter.png",
          "order": 10,
          "metaTitle": "Skydda dina celler med kraftfulla antioxidanter",
          "metaDescription": "Upptäck vårt sortiment av antioxidanttillskott, inklusive vitamin C och E, för att effektivt motverka fria radikaler och skydda dina celler.",
          "metaHeader": "Antioxidanttillskott för cellskydd",
          "subCategories": null
        },
        {
          "id": "67ed329ca77b29394356d9ac",
          "name": "Munvård",
          "slug": "sortiment-munvard",
          "description": "Upprätthåll en god munhygien med våra naturliga munvårdsprodukter, inklusive fluorfri tandkräm och munskölj.\n",
          "thumbnailDescription": "Håll din mun frisk med våra naturliga och fluorfri munvårdsprodukter.",
          "additionalText": "<p>Våra produkter är framtagna för att ge dig en ren och fräsch känsla utan onödiga kemikalier. Perfekt för dig som söker ett naturligt alternativ för din dagliga munvårdsrutin.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_munvård.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_munvård.png",
          "order": 17,
          "metaTitle": "Naturlig Munvård: Fluorfri Tandkräm & Munskölj",
          "metaDescription": "Upptäck vårt sortiment av naturliga munvårdsprodukter för en hälsosam munhygien. Våra fluorfri tandkräm och munskölj är skonsamma och effektiva.",
          "metaHeader": "Naturliga Munvårdsprodukter för Optimal Munhygien",
          "subCategories": null
        },
        {
          "id": "67ed329ca77b29394356d9ad",
          "name": "Vitaminer & Mineraler",
          "slug": "sortiment-vitaminer-mineraler",
          "description": "Säkerställ ett komplett näringsintag med vårt kombinerade utbud av vitaminer och mineraler för daglig hälsa.\n",
          "thumbnailDescription": "Utforska vårt utbud av vitaminer och mineraler för optimal hälsa.",
          "additionalText": "<p>Att upprätthålla en balanserad kost kan vara en utmaning i dagens hektiska värld. Därför erbjuder vi ett brett sortiment av vitaminer och mineraler som kompletterar din dagliga kost och säkerställer att du får alla nödvändiga näringsämnen. Våra produkter är formulerade för att stödja immunförsvaret, förbättra energinivåerna och främja allmän hälsa. Oavsett om du letar efter specifika vitaminer eller en komplett multivitaminlösning, har vi något för alla behov. Utforska vårt sortiment idag och ta ett steg mot en hälsosammare livsstil.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_vitaminer-mineraler.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_vitaminer-mineraler.png",
          "order": 1,
          "metaTitle": "Komplett Näringsintag: Vitaminer och Mineraler för Daglig Hälsa",
          "metaDescription": "Upptäck vårt omfattande sortiment av vitaminer och mineraler som säkerställer ett komplett näringsintag för din dagliga hälsa. Våra produkter är noggrant utvalda för att stödja ditt välbefinnande och ge dig den energi du behöver varje dag.",
          "metaHeader": "Säkerställ Din Hälsa med Våra Vitaminer och Mineraler",
          "subCategories": null
        },
        {
          "id": "67ed329ca77b29394356d9ae",
          "name": "Cellsalter",
          "slug": "sortiment-cellsalter",
          "description": "Stöd kroppens mineralbalans med våra cellsalter, för optimal cellulär funktion och välmående.",
          "thumbnailDescription": "Förbättra din hälsa med cellsalter för optimal mineralbalans.",
          "additionalText": "<p>Våra cellsalter är noggrant utvalda för att säkerställa att din kropp får de nödvändiga mineralerna för att fungera på bästa sätt. Genom att stödja kroppens naturliga processer kan du uppnå en bättre hälsa och ökat välmående. Utforska vårt sortiment idag och upptäck fördelarna med cellsalter.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_cellsalter.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_cellsalter.png",
          "order": 7,
          "metaTitle": "Optimera Din Hälsa med Våra Cellsalter",
          "metaDescription": "Upptäck hur våra cellsalter kan stödja kroppens mineralbalans för optimal cellulär funktion och välmående. Utforska vårt sortiment av högkvalitativa cellsalter.",
          "metaHeader": "Stöd Kroppens Mineralbalans med Våra Cellsalter",
          "subCategories": null
        },
        {
          "id": "67ed329ca77b29394356d9af",
          "name": "Kvinna",
          "slug": "sortiment-kvinna",
          "description": "Produkter speciellt framtagna för kvinnors hälsa, inklusive hormonbalanserande tillskott och järn.",
          "thumbnailDescription": "Hormonbalanserande och järnberikade tillskott för kvinnor.",
          "additionalText": "<p>Vårt sortiment är noggrant utvalt för att möta de unika behoven hos kvinnor. Med fokus på hormonbalans och järn, strävar vi efter att ge dig de bästa förutsättningarna för en hälsosam livsstil. Utforska våra produkter och hitta det som passar just dig.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_kvinna.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_kvinna.png",
          "order": 20,
          "metaTitle": "Optimera Din Hälsa med Våra Kvinnospecifika Produkter",
          "metaDescription": "Upptäck vårt sortiment av produkter framtagna för kvinnors hälsa. Vi erbjuder hormonbalanserande tillskott och järn för att stödja ditt välbefinnande.",
          "metaHeader": "Produkter för Kvinnors Hälsa",
          "subCategories": null
        },
        {
          "id": "67ed329ca77b29394356d9b0",
          "name": "Enzymer",
          "slug": "sortiment-enzymer",
          "description": "Underlätta matsmältningen med våra enzymtillskott, såsom laktas och proteas, för bättre näringsupptag.",
          "thumbnailDescription": "Underlätta matsmältningen med laktas och proteas för bättre näringsupptag.",
          "additionalText": "<p>Våra enzymtillskott är speciellt utformade för att stödja din matsmältningsprocess. Genom att inkludera laktas och proteas i din dagliga rutin kan du effektivt bryta ner laktos och proteiner, vilket leder till ett förbättrat näringsupptag och en mer balanserad matsmältning. Utforska vårt sortiment av högkvalitativa enzymer och upplev skillnaden i din hälsa och välbefinnande.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_enzymer.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_enzymer.png",
          "order": 8,
          "metaTitle": "Förbättra Matsmältningen med Våra Enzymtillskott",
          "metaDescription": "Upptäck hur våra enzymtillskott, inklusive laktas och proteas, kan underlätta din matsmältning och förbättra näringsupptaget.",
          "metaHeader": "Optimera Din Matsmältning med Enzymtillskott",
          "subCategories": null
        },
        {
          "id": "67ed329ca77b29394356d9b1",
          "name": "Litteratur",
          "slug": "sortiment-litteratur",
          "description": "Fördjupa dina kunskaper inom hälsa och välmående med vår litteratur, inklusive böcker om näring och naturlig medicin.",
          "thumbnailDescription": "Böcker om näring och naturlig medicin för en bättre hälsa.",
          "additionalText": "<p>Vår samling av böcker är noggrant utvald för att ge dig de bästa resurserna inom hälsa och välmående. Oavsett om du är intresserad av att förbättra din kost, förstå naturliga behandlingsmetoder eller bara vill lära dig mer om hur du kan leva ett hälsosammare liv, har vi något för dig. Utforska våra titlar och ta det första steget mot en bättre hälsa idag.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_litteratur.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_litteratur.png",
          "order": 28,
          "metaTitle": "Utforska Hälsa och Välmående: Din Guide till Näring och Naturlig Medicin",
          "metaDescription": "Upptäck en värld av kunskap inom hälsa och välmående med vårt omfattande sortiment av litteratur. Våra böcker täcker allt från näring till naturlig medicin, och erbjuder insikter för en hälsosammare livsstil.",
          "metaHeader": "Förbättra Din Hälsa med Vår Litteratur",
          "subCategories": null
        },
        {
          "id": "67ed329da77b29394356d9b4",
          "name": "Barn",
          "slug": "sortiment-barn",
          "description": "Stöd ditt barns utveckling med våra barnanpassade produkter, inklusive vitaminer och omega-3 för de små.",
          "thumbnailDescription": "Vitaminer och omega-3 för ditt barns hälsa.",
          "additionalText": "<p>Vårt sortiment är noggrant utvalt för att säkerställa att ditt barn får de näringsämnen som behövs för en sund tillväxt. Med våra produkter kan du känna dig trygg i att du ger ditt barn det bästa stödet för deras utveckling.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_barn.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_barn.png",
          "order": 21,
          "metaTitle": "Stöd Ditt Barns Utveckling med Våra Barnanpassade Produkter",
          "metaDescription": "Upptäck vårt sortiment av barnanpassade produkter som främjar ditt barns hälsa och utveckling. Vi erbjuder vitaminer och omega-3 speciellt framtagna för de små.",
          "metaHeader": "Barnanpassade Produkter för Optimal Utveckling",
          "subCategories": null
        },
        {
          "id": "67ed329da77b29394356d9b5",
          "name": "Uppiggande",
          "slug": "sortiment-uppiggande",
          "description": "Öka din energi och fokus med våra uppiggande produkter, såsom ginseng och koffeintillskott, för en aktiv livsstil.",
          "thumbnailDescription": "Håll dig pigg och fokuserad med våra ginseng- och koffeintillskott.",
          "additionalText": "<p>Våra uppiggande produkter är speciellt utformade för att ge dig den extra energikick du behöver för att klara av dagens utmaningar. Oavsett om du tränar, arbetar eller bara behöver en boost, kan våra ginseng- och koffeintillskott hjälpa dig att hålla fokus och energi på topp. Utforska vårt sortiment och hitta den perfekta produkten för dina behov.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_uppiggande.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1073/tags/lifeland_uppiggande.png",
          "order": 29,
          "metaTitle": "Öka Energi och Fokus med Våra Uppiggande Produkter",
          "metaDescription": "Upptäck vårt sortiment av uppiggande produkter som ginseng och koffeintillskott. Perfekt för en aktiv livsstil och för att hålla energinivåerna på topp hela dagen.",
          "metaHeader": "Uppiggande Produkter för En Aktiv Livsstil",
          "subCategories": null
        }
      ]
    }
  ],
  "analytics": {
    "gtmId": "GTM-W22M694G",
    "destinations": [
      {
        "type": "GTM",
        "id": "GTM-5X94M583",
        "customMapping": null
      }
    ],
    "mode": null,
    "loadStrategy": null,
    "scriptOrigin": null,
    "sendPageView": null
  },
  "privacy": {
    "cmpType": "COOKIE_SCRIPT",
    "cmpId": "68f398f340cfc786a2af7f1e1ec069ba",
    "manageConsentDefaults": null,
    "defaultConsent": null
  },
  "assistant": {
    "id": null,
    "name": null,
    "imgUrl": null,
    "company": "Lifeland"
  },
  "storeType": "B2C",
  "storeDeliveries": [
    {
      "id": "67ed299e0f4d1c6e0b3efcfd",
      "name": "Finns i Lager",
      "label": "Finns i Lager",
      "buyable": true
    },
    {
      "id": "68c7c34e81b5ac54207f7789",
      "name": "Finns ej i Lager",
      "label": "Finns ej i Lager",
      "buyable": false
    }
  ],
  "language": "sv",
  "currency": "SEK",
  "labels": {
    "currency": "SEK",
    "priceCurrency": "SEK"
  },
  "paths": {
    "brandsUrlPath": "/brands",
    "categoriesUrlPath": "/categories",
    "tagsUrlPath": "/tags",
    "productsUrlPath": "/products",
    "blogsUrlPath": "/blog"
  },
  "staticLinks": [
    {
      "id": "blog",
      "label": "Hälsomagasinet",
      "path": "/blog"
    },
    {
      "id": "brands",
      "label": "Varumärken",
      "path": "/brands"
    },
    {
      "id": "minasidor",
      "label": "Mina sidor",
      "path": "/account"
    }
  ],
  "logoUrl": "https://storage.googleapis.com/gecko-media/EC_1073/LifeLand_logo_white_bolder.png",
  "showCart": true,
  "sortingOptions": [
    {
      "sortBy": "price",
      "sortOrder": "DESC",
      "sortLabel": "Pris högt-lågt",
      "default": false
    },
    {
      "sortBy": "price",
      "sortOrder": "ASC",
      "sortLabel": "Pris lågt-högt",
      "default": true
    },
    {
      "sortBy": "created",
      "sortOrder": "DESC",
      "sortLabel": "Nyaste",
      "default": false
    }
  ],
  "desktopItemHeight": "20vw",
  "mobileItemHeight": "75vw",
  "maxContentWidth": 1270,
  "menuMaxContentWidth": 1270,
  "collapsibleDiscountCodeForm": true,
  "sliderDefaultValues": [
    0,
    5000
  ],
  "freeShippingOver": 700,
  "shippingProviderConfig": {
    "provider": "POSTNORD",
    "simpleShipping": {
      "minimumOrderAmountForFreeDelivery": 700,
      "deliveryFee": 139
    },
    "postnordOptions": {
      "applicationId": 2341,
      "customerKey": "20716344",
      "companyName": "Ez Hälsa AB",
      "conditionalDeliveryTypes": [
        {
          "type": "express-mailbox",
          "conditions": [
            {
              "countries": [
                "SE"
              ],
              "orderAmount": {
                "from": 0,
                "to": 400
              }
            }
          ]
        },
        {
          "type": "service-point",
          "conditions": null
        },
        {
          "type": "parcel-locker",
          "conditions": null
        },
        {
          "type": "home",
          "conditions": null
        }
      ],
      "warehouses": [
        {
          "id": "warehouse1",
          "address": {
            "city": "Stockholm",
            "countryCode": "SE",
            "postCode": "11327",
            "street": "Norrtullsgatan 25A",
            "streetName": null,
            "streetNumber": null
          },
          "orderHandling": {
            "daysUntilOrderIsReady": "0-2",
            "handOverTimer": null,
            "timeOfLatestOrder": null
          }
        }
      ],
      "costs": [
        {
          "deliveryType": "default",
          "conditionalCosts": [
            {
              "deliveryFee": 39,
              "minimumOrderAmountForFreeDelivery": 700,
              "conditions": [
                {
                  "countries": [
                    "SE"
                  ],
                  "orderAmount": null
                }
              ]
            },
            {
              "deliveryFee": 169,
              "minimumOrderAmountForFreeDelivery": -1,
              "conditions": null
            }
          ]
        },
        {
          "deliveryType": "service-point",
          "conditionalCosts": [
            {
              "deliveryFee": 52,
              "minimumOrderAmountForFreeDelivery": 700,
              "conditions": [
                {
                  "countries": [
                    "SE"
                  ],
                  "orderAmount": {
                    "from": 0,
                    "to": 400
                  }
                }
              ]
            }
          ]
        },
        {
          "deliveryType": "parcel-locker",
          "conditionalCosts": [
            {
              "deliveryFee": 52,
              "minimumOrderAmountForFreeDelivery": 700,
              "conditions": [
                {
                  "countries": [
                    "SE"
                  ],
                  "orderAmount": {
                    "from": 0,
                    "to": 400
                  }
                }
              ]
            }
          ]
        },
        {
          "deliveryType": "home",
          "conditionalCosts": [
            {
              "deliveryFee": 125,
              "minimumOrderAmountForFreeDelivery": -1,
              "conditions": [
                {
                  "countries": [
                    "SE"
                  ],
                  "orderAmount": null
                }
              ]
            }
          ]
        }
      ],
      "availableCountries": [
        "SE",
        "DK",
        "NO",
        "FI",
        "AT",
        "BE",
        "CZ",
        "EE",
        "FR",
        "DE",
        "IE",
        "LV",
        "LT",
        "LU",
        "NL",
        "PL",
        "PT",
        "SK",
        "SI",
        "ES"
      ]
    }
  },
  "paymentProviderConfig": {
    "providerName": "QLIRO",
    "providerOptions": {
      "qliro": {
        "countryCode": "SE",
        "availableCountries": [
          "SE",
          "DK",
          "NO",
          "FI",
          "AT",
          "BE",
          "CZ",
          "EE",
          "FR",
          "DE",
          "IE",
          "LV",
          "LT",
          "LU",
          "NL",
          "PL",
          "PT",
          "SK",
          "SI",
          "ES"
        ],
        "purchaseCurrency": "SEK",
        "termsUrl": "/kop-och-leveransvillkor",
        "integrityPolicyUrl": "/integritetspolicy",
        "requireIdentityVerification": null,
        "minimumCustomerAge": null,
        "enforcedJuridicalType": null,
        "backgroundColor": null,
        "primaryColor": null,
        "callToActionColor": null,
        "callToActionHoverColor": null,
        "cornerRadius": null,
        "buttonCornerRadius": null
      }
    }
  },
  "filtersBeforeShowMore": 3,
  "sliderMaxPrice": 5000,
  "topNavHeight": {
    "panel": {
      "base": 0,
      "sm": "5vh"
    },
    "content": {
      "base": "8vh",
      "sm": "14vh"
    },
    "spacer": {
      "base": "8vh",
      "sm": "19vh"
    }
  },
  "topNavSlideOutFeaturedCategories": 3,
  "socialMediaItems": [
    {
      "label": "Facebook",
      "icon": "FACEBOOK",
      "href": "https://www.facebook.com/LifelandAB"
    }
  ],
  "topNavPanel": {
    "items": [
      {
        "icon": "FaCrown",
        "label": "Om oss",
        "href": "/om-oss"
      },
      {
        "icon": "MdOutlineLocalShipping",
        "label": "Gratis frakt på ordrar över 700 kr"
      },
      {
        "icon": "FaCrown",
        "label": "Kontakta oss",
        "href": "/kontakta-oss"
      }
    ]
  },
  "menuCategoriesConfig": {
    "desktop": {
      "variant": "multi-column"
    },
    "mobile": {
      "variant": "multi-column"
    }
  },
  "footerConfig": {
    "maxColumns": 5
  },
  "searchProductList": {
    "variant": "horizontal-filter",
    "columnsNumber": 5,
    "columnsNumberTablet": 4
  },
  "searchQueryMinLength": 1
};
export const serverTheme = {
  "components": {
    "Button": {
      "baseStyle": {
        "borderRadius": "full",
        "backgroundColor": "#226E57",
        "size": "sm",
        "color": "text.light",
        "fontWeight": "medium",
        "minW": 140,
        "outlineOffset": 0,
        "transition": "all 0.35s cubic-bezier(.08,.52,.52,1)"
      }
    },
    "CustomFooter": {
      "bg": "#226E57",
      "textColor": "#FFFFFF"
    },
    "GrandOverlay": {
      "bg": "rgba(0,0,0, 0.25)"
    },
    "ProductDeliveryGuaranty": {
      "display": "none"
    },
    "ProductDeliveryInstallation": {
      "display": "none"
    },
    "searchComponents": {
      "SearchComponentInputWrapper": {},
      "SearchComponentButtonWrapper": {},
      "SearchComponentPopover": {},
      "SearchComponentPopoverContent": {},
      "SearchInputWrapper": {},
      "SearchInputGroup": {
        "size": "md",
        "minWidth": "0",
        "width": "45vw",
        "maxWidth": "560px"
      },
      "SearchInput": {
        "_placeholder": {
          "fontSize": "sm"
        }
      },
      "SearchButton": {}
    }
  },
  "colors": {
    "primary": "#226E57",
    "secondary": "#E6E6E6",
    "klarna": "#315D91",
    "background": {
      "default": "#FFF",
      "surface": "#FFFFFF",
      "mildDark": "rgb(1,50,75)",
      "dark": "rgb(0,25,38)",
      "darkest": "rgb(0,19,28)",
      "translucent": "rgba(34,110,87, 100)",
      "overlayHalf": "rgba(0,0,0, 0.25)",
      "overlay": "rgba(0,0,0, 0.5)",
      "primary": "rgba(146,176,156, .1)",
      "secondary": "rgba(205,15,50, .1)"
    },
    "text": {
      "default": "#000000",
      "disabled": "#9DB1BC",
      "mild": "#5A7A84",
      "light": "white",
      "darkGrey": "#323a3a",
      "colored": "#315d91"
    },
    "status": {
      "success": "rgba(29,195,149, 1)",
      "warning": "#eed892",
      "warning2": "#f5e6d6",
      "error": "#f35f5f"
    },
    "brand": {
      "10": "#E6F0ED",
      "50": "#C4DED6",
      "100": "#9CC9BC",
      "200": "#78BAA6",
      "300": "#4EA68C",
      "400": "#37866E",
      "500": "#226E57",
      "600": "#20624E",
      "700": "#165F49",
      "800": "#164B3B",
      "900": "#113B2F",
      "1000": "#0E2F25",
      "1100": "#0A241C",
      "darkExtraLight": "rgba(0,25,38,0.20)",
      "darkGrey": "#222222"
    },
    "customColorScheme": {
      "10": "#E6F0ED",
      "50": "#C4DED6",
      "100": "#9CC9BC",
      "200": "#78BAA6",
      "300": "#4EA68C",
      "400": "#37866E",
      "500": "#226E57",
      "600": "#20624E",
      "700": "#165F49",
      "800": "#164B3B",
      "900": "#113B2F",
      "1000": "#0E2F25",
      "1100": "#0A241C"
    },
    "component": {
      "TopNavContent": {
        "root": {
          "background": "#226e57",
          "_menuIsOpened": {
            "background": "#226e57"
          }
        },
        "hamburger": {
          "color": "#212626"
        },
        "MenuItem": {
          "color": "#fff",
          "_menuIsOpened": {
            "color": ""
          },
          "_active": {
            "color": "#2cc009"
          },
          "_active_menuIsOpened": {
            "color": ""
          }
        }
      }
    }
  }
}; 
